class DateCounter extends HTMLElement {
  constructor() {
    super();

    this.countdownDateAttr = null;
    this.countdownDate = null;
    this.days = null;
    this.hours = null;
    this.minutes = null;
    this.seconds = null;
    this.countdownTimer = null;
    this.timerEnded = null;
  }

  connectedCallback() {
    const durationMinutes = this.getAttribute('data-duration-minutes');
    if (durationMinutes !== null && durationMinutes !== '') {
      const minutes = parseInt(durationMinutes, 10);
      if (!Number.isNaN(minutes) && minutes > 0) {
        this.countdownDate = new Date(Date.now() + minutes * 60 * 1000);
      }
    }
    if (!this.countdownDate) {
      this.countdownDateAttr = this.getAttribute('data-end-date');
      this.countdownDate = this.parseDate(this.countdownDateAttr);
    }
    if (isNaN(this.countdownDate?.getTime())) {
      console.error('Invalid countdown: use "Duration" mode with minutes or set a valid end date.');
      return;
    }
    this.displayStyle = this.getAttribute('data-display-style') || 'cards';
    this.days = this.querySelector('[data-ref="days"]');
    this.hours = this.querySelector('[data-ref="hours"]');
    this.minutes = this.querySelector('[data-ref="minutes"]');
    this.seconds = this.querySelector('[data-ref="seconds"]');
    this.inlineValue = this.querySelector('[data-ref="inline-value"]');
    this.countdownInline = this.querySelector('[data-ref="countdown-inline"]');
    this.countdownTimer = this.querySelector('[data-ref="countdown-timer"]');
    this.timerEnded = this.querySelector('[data-ref="timer-ended"]');

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  parseDate(dateStr) {
    // Format attendu : 03/11/2025 14:30
    const dateTimeParts = dateStr.match(/(\d{2})\/(\d{2})\/(\d{4})\s(\d{2}):(\d{2})/);
    if (dateTimeParts) {
      const [_, day, month, year, hour, minute] = dateTimeParts;
      return new Date(year, month - 1, day, hour, minute);
    }

    // Si le format n'est pas reconnu, retourne une date invalide
    return new Date('Invalid Date');
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.countdownDate.getTime() - now;

    if (distance < 0) {
      this.countdownTimer.classList.add('hidden');
      if (this.countdownInline) this.countdownInline.classList.add('hidden');
      if (this.timerEnded.dataset.showMessage === 'true') {
        this.timerEnded.classList.remove('hidden');
      } else {
        this.closest('[data-ref="countdown"]').classList.add('hidden');
      }

      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (this.displayStyle === 'inline' && this.inlineValue) {
      const totalMinutes = Math.floor(distance / (1000 * 60));
      const remainingSeconds = Math.floor((distance % (1000 * 60)) / 1000);
      this.inlineValue.textContent = `${totalMinutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    } else {
      this.days.textContent = days;
      this.hours.textContent = hours.toString().padStart(2, '0');
      this.minutes.textContent = minutes.toString().padStart(2, '0');
      this.seconds.textContent = seconds.toString().padStart(2, '0');
    }
  }
}

class InlineDateCounter extends HTMLElement {
  constructor() {
    super();

    this.countdownDate = null;
    this.timerValue = null;
    this.interval = null;
  }

  connectedCallback() {
    this.timerValue = this.querySelector('[data-ref="timer-value"]');
    this.countdownDate = DateCounter.prototype.parseDate.call(this, this.getAttribute('data-end-date'));

    if (!this.timerValue || isNaN(this.countdownDate)) {
      console.error('Invalid inline timer configuration:', this.getAttribute('data-end-date'));
      return;
    }

    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.interval);
  }

  updateCountdown() {
    const now = Date.now();
    const distance = this.countdownDate.getTime() - now;
    const timerWrapper = this.closest('[data-ref="mix-match-timer"]');
    const hideWhenEnded = this.getAttribute('data-hide-when-ended') === 'true';
    const endedText = this.getAttribute('data-ended-text');

    if (distance < 0) {
      if (hideWhenEnded) {
        timerWrapper?.classList.add('is-ended');
      } else if (endedText) {
        this.timerValue.textContent = endedText;
      } else {
        this.timerValue.textContent = '0j 00h 00m';
      }

      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));

    this.timerValue.textContent = `${days}j ${hours.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m`;
  }
}

customElements.define('date-counter', DateCounter);
customElements.define('inline-date-counter', InlineDateCounter);
